<script setup lang="ts">
import { ref, watch } from 'vue'

import BaseModal from '@/components/BaseModal.vue'
import BaseButton from '@/components/ui/BaseButton.vue'
import TourTypeSelect from '@/components/ui/TrackAndTourTypeSelect.vue'

const props = defineProps<{
  isOpen: boolean
  mode: 'tour' | 'route'
}>()

const emit = defineEmits<{
  close: []
  create: [payload: { type?: string }]
}>()

const selectedType = ref<string | undefined>(undefined)

watch(
  () => props.isOpen,
  (isOpen) => {
    if (isOpen) {
      selectedType.value = undefined
    }
  },
)

const handleCreate = () => {
  emit('create', { type: selectedType.value })
}
</script>

<template>
  <BaseModal
    :is-open="isOpen"
    :title="mode === 'route' ? 'Create New Route' : 'Add New Tour'"
    :description="
      mode === 'route'
        ? 'Choose an activity type for the route you are about to create.'
        : 'Choose an activity type for the first track you add to this new tour.'
    "
    size="md"
    show-footer
    @close="$emit('close')"
  >
    <div class="space-y-4">
      <TourTypeSelect v-model="selectedType" label="Activity Type" />
      <p class="text-xs text-gray-500">
        {{
          mode === 'route'
            ? 'The selected type will be applied to the route track when drawing starts.'
            : 'The selected type will be remembered and applied to the first track created in this tour.'
        }}
      </p>
    </div>

    <template #footer>
      <div class="flex justify-end gap-3">
        <BaseButton variant="secondary" @click="$emit('close')">Cancel</BaseButton>
        <BaseButton variant="primary" @click="handleCreate">Create</BaseButton>
      </div>
    </template>
  </BaseModal>
</template>
